import {
  BioSampleCodeFormatType,
  BioSampleContainerRefBase,
  BioSampleRef,
  BioSampleRefBase,
} from '@csp/csp-common-hbs-model';
import { BioSampleCodeFormatterUtil } from './BioSampleCodeFormatterUtil';

const isKitOrContainerNumberUpdatedOnAny = <T extends BioSampleRef>(
  originalSamples: T[],
  updatedSamples: T[],
): boolean =>
  updatedSamples.some(updatedSample => {
    const originalSample = originalSamples.find(
      originalSample => originalSample.sampleCode === updatedSample.sampleCode,
    );
    return (
      originalSample &&
      (originalSample.kitCode !== updatedSample.kitCode ||
        originalSample.containerNumber !== updatedSample.containerNumber)
    );
  });

const isSameContainerRef = (ref1: BioSampleContainerRefBase, ref2: BioSampleContainerRefBase): boolean =>
  ref1.kitCode === ref2.kitCode && ref1.containerNumber === ref2.containerNumber;

const isSameSampleCodeOrContainerRef = (ref1: BioSampleRefBase, ref2: BioSampleRefBase): boolean =>
  (ref1.kitCode === ref2.kitCode && ref1.containerNumber === ref2.containerNumber) ||
  ref1.sampleCode === ref2.sampleCode;

const includesContainerRef = (containerRef: BioSampleContainerRefBase, refs: BioSampleContainerRefBase[]): boolean =>
  refs.some(ref => isSameContainerRef(containerRef, ref));

const includesSampleCodeOrContainerRef = (sampleRef: BioSampleRefBase, refs: BioSampleRefBase[]): boolean => {
  const sampleCodes = refs.map(ref => ref.sampleCode);
  return includesContainerRef(sampleRef, refs) || sampleCodes.includes(sampleRef.sampleCode);
};

const isSameContainerRefIgnoreZeroPadding = (
  ref1: BioSampleContainerRefBase,
  ref2: BioSampleContainerRefBase,
  format: BioSampleCodeFormatType,
): boolean => {
  const containerNumber1 = ref1.containerNumber
    ? BioSampleCodeFormatterUtil.toBioSampleContainerNumber(ref1.containerNumber, [format])
    : ref1.containerNumber;
  const containerNumber2 = ref2.containerNumber
    ? BioSampleCodeFormatterUtil.toBioSampleContainerNumber(ref2.containerNumber, [format])
    : ref2.containerNumber;

  return isSameContainerRef(
    {
      ...ref1,
      containerNumber: containerNumber1 !== 'NaN' ? containerNumber1 : ref1.containerNumber,
    },
    {
      ...ref2,
      containerNumber: containerNumber2 !== 'NaN' ? containerNumber2 : ref2.containerNumber,
    },
  );
};

export const BioSampleRefUtil = {
  isKitOrContainerNumberUpdatedOnAny,
  includesContainerRef,
  isSameContainerRef,
  includesSampleCodeOrContainerRef,
  isSameSampleCodeOrContainerRef,
  isSameContainerRefIgnoreZeroPadding,
};
